<div class="terms">
  <div class="single-checkbox">
    <input tabindex="0" role="checkbox" type="checkbox" name="terms" value="1" id="terms" (change)="onChange($event)">
    <label for="terms" [innerHTML]="textPrefix + 'terms.label' | translate"></label>
  </div>
  <p [innerHTML]="textPrefix + 'terms.description.short' | translate: {portalId: portalId}"></p>
  @if (!showMore) {
    <p><button type="button" class="toggle" [attr.aria-expanded]="showMore" aria-controls="details" (click)="showMore = !showMore" [innerHTML]="textPrefix + 'terms.more' | translate"></button></p>
  }
  @if (showMore) {
    <p id="details" [innerHTML]="textPrefix + 'terms.description.long' | translate"></p>
  }
  @if (showMore) {
    <button class="toggle" [attr.aria-expanded]="showMore" aria-controls="details" (click)="showMore = !showMore">{{textPrefix + 'terms.less' | translate}}</button>
  }
</div>
